import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'
import { HTTPMultipartFormData } from '@/api/http-multipart-form'

export default {
  getProduct (callback, param) {
    let decodeSku = decodeURIComponent(param.sku)
    let skurep = decodeSku.replace(/%|\+/g, (a) => a == '%' ? '_--_' : '!_-!')
    let url = param.publicToken + '/products/' + encodeURIComponent(skurep) + '?languageId=' + param.languageId
    HTTP.get(url).then(response => {
      callback(response)
    }).catch(e => {
      if (e.response.status == '400') {
        console.log('400 products api ', param)
        callback(e.response)
      } else {
        console.log(e)
      }
    })
  },
  order (callback, param) {
    if (param.system === 'Velaeasy') {
      HTTP.post(param.token + '/orders', param).then(response => {
        callback(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          if (e.response.data.data.code === '04' || e.response.data.data.code === '10' || e.response.data.data.code === '11') {
            callback(e.response.data)
          } else {
            alert(e.response.data.data.message)
          }
        } else {
          console.log(e)
        }
      })
    } else {
      HTTP.post(param.token + '/shappy/orders', param).then(response => {
        callback(response.data)
      }).catch(e => {
        if (e.response.status == '400') {
          if (e.response.data.data.code === '04' || e.response.data.data.code === '10' || e.response.data.data.code === '11') {
            callback(e.response.data)
          } else {
            alert(e.response.data.data.message)
          }
        } else {
          console.log(e)
        }
      })
    }
  },
  getOrderUrl (param) {
    if (param.system === 'Velaeasy') {
      return HttpFunctions.getApiBaseUrl() + param.token + '/orders'
    } else {
      return HttpFunctions.getApiBaseUrl() + param.token + '/shappy/orders'
    }
  },
  sendPaymentSlipData (callback, param) {
    HTTPMultipartFormData.post(param.token + '/orders/payment_slip', param.formData).then(response => {
      callback(response.data)
    }).catch(e => {
      console.log(e)
      if (e.response.status === 400 || e.response.status === 500) {
        callback(e.response)
      }
    })
  },
  getOrderDetail (callback, param) {
    let url = param.token + '/orders/' + param.orderId
    HTTP.get(url).then(response => {
      callback(response)
    }).catch(e => {
      if (e.response.status == '400') {
      console.log('400 products api ', param)
    } else {
      console.log(e)
    }
  })}
}



// WEBPACK FOOTER //
// ./src/api/products/index.js